import React, { useEffect } from "react";
import { PlanStore } from "../store/planStore";
import { Redirect, Route } from "react-router-dom";
import InPlayer from "../backend/inplayer";
import Global from "../../global";
import Cookies from "js-cookie";

const SubscribeRoute = ({ component: Component, ...rest }) => {
  const plan = PlanStore.useState((s) => s.plan);
  const phone_verifed = Cookies.get("sm_ott_val") === "true";

  useEffect(() => {});

  return (
    <Route
      {...rest}
      render={(props) =>
        InPlayer.Account.isAuthenticated() ? (
          !phone_verifed &&
          Global.OTP &&
          props.location.pathname !==
            "/" + props.match.params.AppId + "/verify" &&
          props.location.pathname !==
            "/" + props.match.params.AppId + "/sendotp" ? (
            <Redirect
              to={{
                pathname: "/" + props.match.params.AppId + "/sendotp",
                state: { from: props.location },
              }}
            />
          ) : plan !== null ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/" + props.match.params.AppId + "/premium",
                state: { from: props.location },
              }}
            />
          )
        ) : (
          <Redirect
            to={{
              pathname: "/" + props.match.params.AppId + "/welcome",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default SubscribeRoute;
